import { NgIf } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

@Component({
  templateUrl: './column-quantity-unit-information.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, AgrI18nSharedModule],
})
export class ColumnQuantityUnitInformationComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<unknown>;
  public editable: boolean;
  public initCallback: () => void;

  ngAfterViewInit() {
    this.initCallback();
  }
}
